import { SessionData } from 'owa-service/lib/types/SessionData';
import { isNative } from 'owa-config';
import { InitialMailData, lazyGetInitialMailDataHx } from 'hx-initial-mail-data';
import { markFunction } from 'owa-performance';
import { trace } from 'owa-trace';

export const getInitialMailData = markFunction(
    async (sessionData: SessionData): Promise<InitialMailData | null> => {
        try {
            // For web, since schema conversion depends on feature flags which aren't
            // initialized yet, we wait to convert to gql schema until reading from the stash.
            if (isNative()) {
                return lazyGetInitialMailDataHx.importAndExecute();
            }
        } catch (error) {
            trace.warn('getInitialMailData: ' + error.message);
        }

        return null;
    },
    'imd'
);
